namespace TabAurous.Finance {
    export interface ReceiptDetailsForm {
        TransDetailId: Serenity.StringEditor;
        LedgerId: Serenity.LookupEditor;
        Mode: Serenity.LookupEditor;
        Amount: Serenity.DecimalEditor;
        ExchangeRateId: Serenity.DecimalEditor;
        ChequeNo: Serenity.StringEditor;
        ChequeDate: Serenity.DateEditor;
        RefNo: Serenity.StringEditor;
    }

    export class ReceiptDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.ReceiptDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReceiptDetailsForm.init)  {
                ReceiptDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.DateEditor;

                Q.initFormType(ReceiptDetailsForm, [
                    'TransDetailId', w0,
                    'LedgerId', w1,
                    'Mode', w1,
                    'Amount', w2,
                    'ExchangeRateId', w2,
                    'ChequeNo', w0,
                    'ChequeDate', w3,
                    'RefNo', w0
                ]);
            }
        }
    }
}
